import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-my-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class MapComponent {

    @Input() centerLat: number;
    @Input() centerLng: number;
    @Input() lat: number;
    @Input() lng: number;
    @Input() latM: number;
    @Input() lngM: number;
    @Input() titleM: string;
    @Input() mechanicMarkerVisible: boolean;
    @Input() zoomControl: boolean;

    zoom = 16;
    mainFitBounds: boolean = true;
    streetViewControl = false;
    iconUrl = 'images/wrench-pin-32x32.png';

    mapReady(map: any) {
        this.mainFitBounds = this.mechanicMarkerVisible ? this.mechanicMarkerVisible : false;
    }
}
